import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { DwoChecklistComponent } from './dwo-checklist/dwo-checklist/dwo-checklist.component';
import { DwoDiagnoseComponent } from './dwo-diagnose/dwo-diagnose/dwo-diagnose.component';
import { MechanicClockinComponent } from './mechanic-clockin/mechanic-clockin.component';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import * as enums from 'projects/Autofacets-Core/src/app/utils/enums'
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { SstChecklistComponent } from './dwo-diagnose/sst-checklist/sst-checklist.component';

const DWOTabs: { id: number, label: string, route: string }[] = [
  { id: 1, label: 'lblMechanicClockIn', route: 'clockIn' },
  { id: 2, label: 'lblDwoDiagnose', route: 'diagnose' },
  { id: 3, label: 'lblSstCheckList', route: 'sstchecklist' },
  { id: 4, label: 'lblCheckList', route: 'checklist' },
  { id: 5, label: 'lblPhoto/Video', route: 'documents' },
  { id: 6, label: 'lblComments', route: 'comments' },
  { id: 7, label: 'lblMechanicComments', route: 'demand-comments' }
]
@Component({
  selector: 'app-appointment-dwo',
  templateUrl: './appointment-dwo.component.html',
})
export class AppointmentDWOComponent implements OnInit {
  tabs: { id: number, label: string, route: string }[] = DWOTabs;
  showCancel: boolean = false;
  @Input() isFromArchive: boolean | undefined;
  @ViewChild(DwoDiagnoseComponent) childDwoDiagnoseComponent: DwoDiagnoseComponent;
  @ViewChild(DwoChecklistComponent) childDwoChecklistComponent: DwoChecklistComponent;
  @ViewChild(MechanicClockinComponent) mechanicClockinComponent: MechanicClockinComponent;
  @ViewChild(SstChecklistComponent) sstChecklistComponent: SstChecklistComponent;
  brandName : any;
  isSST: boolean = false;
  features: Features[] = [];
  isFromArchiveFlag: boolean = false;
  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly editAppointmentService: EditAppointmentService,
    private readonly secureStorage: SecureStorage
  ) { }
  selectedDWOTab: number = 1;

  ngOnInit(): void {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.isFromArchive !== undefined) {
      this.isFromArchiveFlag = this.isFromArchive;
    }
    if(this.features?.length > 0)
    {
      this.isSST = this.features.find(x => x.featureCode === enums.FeatureCode.SST)?.isActive;
    }
    this.brandName = this.editAppointmentService.appointmentDetails.brandName.toLowerCase();
    this.filteredTabs();
    this.showCancel = !this.editAppointmentService.isFromHistoricalWOTab;
    if(this.editAppointmentService.selectedChildTabNumber === 1)
    {
      this.mechanicClockinComponent?.ngOnInit();
    }
    else if(this.editAppointmentService.selectedChildTabNumber === 2)
    {
      this.childDwoChecklistComponent?.ngOnInit();
    }
    else if(this.editAppointmentService.selectedChildTabNumber === 3)
    {
      this.sstChecklistComponent?.ngOnInit();
    }
  }

  filteredTabs() {
    if (this.brandName == 'nissan' && this.isSST) {
      return this.tabs;
    } else {
      this.tabs = this.tabs.filter(x => x.label != 'lblSstCheckList');
      return this.tabs.filter(tab => tab.id != 3); ; 
    }
  }

  OnClose() {
    this.activeModal.close({success: false});
  }
}
